import { IServerPagination } from "app/model"
import { getStore } from "app/store/store"
import { ICampaignList, ICampaignRefreshListParams } from "campaign/model"
import { campaignRPO } from "campaign/repository"
import { campaignActionCreator } from "campaign/store/actions"
import { loadListDspDeal } from "./dsp-deal"
import { loadListCampaignEstimates } from "./estimate"
import { loadListCampaignReports } from "./reports"

export async function refreshCampaignList(params: ICampaignRefreshListParams): Promise<void> {
  let { pagination, filters } = params
  const { isForecast, isDspDeal } = params
  const campaignState = getStore().getState().campaign
  const list = isForecast
    ? campaignState.forecastList
    : isDspDeal
      ? campaignState.dspDealList
      : campaignState.campaignList
  getStore().dispatch(
    campaignActionCreator.setList(isForecast, isDspDeal, { isRefreshing: true, hasRefreshError: false })
  )
  if (!pagination) {
    pagination = list.pagination
  }
  let rowCount: number = list.rowCount
  if (!filters) {
    filters = list.filters
  }
  try {
    rowCount = await campaignRPO.getCampaignsCount(filters, isDspDeal ? "Deal" : "RTB")
  } catch (error) {
    console.error(error)
    getStore().dispatch(
      campaignActionCreator.setList(isForecast, isDspDeal, {
        isRefreshing: false,
        hasRefreshError: true,
        filteredEntities: []
      })
    )
    return
  }
  try {
    const newList: Partial<ICampaignList> = {
      isRefreshing: false,
      hasRefreshError: false,
      rowCount
    }
    if (params.pagination) {
      newList.pagination = pagination
    } else {
      newList.pagination = list.pagination
    }
    if (rowCount < newList.pagination.page * newList.pagination.pageSize) {
      newList.pagination.page = 0
    }
    if (params.filters) {
      newList.filters = params.filters
    }
    newList.filteredEntities = await campaignRPO.getCampaigns(
      newList.pagination || pagination,
      newList.filters || filters,
      isDspDeal ? "Deal" : "RTB"
    )
    getStore().dispatch(campaignActionCreator.setList(isForecast, isDspDeal, newList))
    if (!isForecast && !isDspDeal) {
      loadListCampaignReports()
    }
    if (!isDspDeal) {
      loadListCampaignEstimates(isForecast)
    } else {
      await loadListDspDeal()
    }
  } catch (error) {
    console.error(error)
    getStore().dispatch(
      campaignActionCreator.setList(isForecast, isDspDeal, {
        isRefreshing: false,
        hasRefreshError: true,
        filteredEntities: []
      })
    )
  }
}

export function getDefaultCampaignPagination(): IServerPagination {
  return {
    pageSize: 10,
    page: 0,
    orderBy: "created_at",
    order: "desc"
  }
}
